export interface Customer {
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  lastEmailRequested: string;
  lastSMSRequested: string;
  employeeFirstName: string;
  employeeLastName: string;
  emailRequestStatus: number;
  smsRequestStatus: number;
  smsErrorCode: number;
  createdOn: string;
  reviewStarRating?: number;
  reviewUrl?: string;
  emailLastClickedSource: number;
  smsLastClickedSource: number;
  tag: string;
  origin?: string;
}

export interface NewCustomerJson {
  [key: string]: string;
}

export interface NewCustomer {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  employeeFirstName: string;
  employeeLastName: string;
  tag: string;
}

export const sendingRequestStatus = 10;

export enum RequestStatus {
  NOT_SENT = 0,
  LEFT_REVIEW = 1,
  DELIVERED = 2,
  BOUNCED = 3,
  OPENED = 4,
  CLICKED = 5,
  CLICKED_POSITIVE = 6,
  CLICKED_NEGATIVE = 7,
  UNSUBSCRIBE = 8,
  SPAM_REPORT = 9,
  SENDING = 10,
  DROPPED = 11,
}

export enum EventType {
  PROCESSED = 'processed',
  DELIVERED = 'delivered',
  BOUNCED = 'bounce',
  BOUNCED_ALIAS = 'bounced',
  OPENED = 'open',
  OPENED_ALIAS = 'opened',
  CLICKED = 'click',
  CLICKED_ALIAS = 'clicked',
  CLICKED_POSITIVE = 'clicked-positive',
  CLICKED_NEGATIVE = 'clicked-negative',
  UNSUBSCRIBE = 'unsubscribed',
  SPAM_REPORT = 'spamreport',
  DROPPED = 'dropped',
  DEFERRED = 'deferred',
}
